export default __webpack_public_path__ + "static/media/iconG4.2506a802.png";